import * as React from 'react';
import { resolve } from 'inversify-react';
import { Link } from 'react-router-dom';

import { FormatService } from 'src/core/services/format.service';
import { ZuluIcon } from 'src/app/shared/icon';
import { UserEditorController } from '../../users/parts/user-editor.controller';

interface Props {
	item: UserTaskSummary;

	onItemDoubleClick: (item: UserTaskSummary) => void;
	onRemove: (item: UserTaskSummary) => void;
}

interface State {
	showBody: boolean;
	showHistory: boolean;
}

export default class TaskCard extends React.Component<Props, any> {

	@resolve
	formatService: FormatService;

	constructor(props) {
		super(props);

		this.state = {
			showBody: true,
			showHistory: false
		}
	}


	mapStatus = (text: number) => {
		switch (text) {
			case 0:
				return 'New';
			case 1:
				return 'In progress';
			case 2:
				return "Finished";
			case 4:
				return "Cancelled"
			case 8:
				return "Out of Date"
		}
	}


	mapStatusCss = (text: number) => {
		switch (text) {
			case 0:
				return 'new';
			case 1:
				return 'in-progress';
			case 2:
				return "finished";
			case 4:
				return "cancelled"
			case 8:
				return "out-of-date"
		}
	}

	drawReferenceLink = () => {
		const item = this.props.item;
		switch (item.modelType) {
			case 'product':
				return <Link to={'/products/products/' + item.modelId}>Product</Link>;
			case 'quoteEntry':
				return <Link to={'/bookings/confirmation-quotes?id=' + item.modelId}>Quote entry</Link>;
			case 'quote':
				return <Link to={'/bookings/quotes/' + item.modelId}>Quote</Link>;
			case 'client':
				return <Link to={'/crm/clients/' + item.modelId}>Client</Link>;
		}

	}

	render() {
		const item = this.props.item;
		var history = item.dynamicProperties;

		return (
			<div className="task-card" key={"task" + item.id}>
				<div className={"status-brand " + this.mapStatusCss(item.state)}>
				</div>
				<div className="task-info">
					<div className="task-header">
						<h2 className="task-title">{item.title}</h2>
					</div>

					<div className="task-info">
						<div className="task-header">
							<h4 className="task-user">Assigned to: <strong>{item.assignedToUserName}</strong></h4>
							<h4 className="task-date">Deadline: <strong>{this.formatService.toString('date-time', item.daedline, 'utc')}</strong></h4>
							<h4 className="task-status">Status: <strong>{this.mapStatus(item.state)}</strong></h4>
							<h4 className="task-priority">Priority: <strong>{item.priority}</strong></h4>
							<h4 className="task-priority">Reference: <strong>{this.drawReferenceLink()}</strong></h4>

						</div>
					</div>
					<div className='task-toolbox'>
						<ZuluIcon type={'edit'} onClick={() => this.props.onItemDoubleClick(item)} />
						<ZuluIcon type={'delete'} onClick={() => this.props.onRemove(item)} />
						{<ZuluIcon type={'clock-circle'} onClick={() => this.setState({ showHistory: true, showBody: false })} />}
						<ZuluIcon type={this.state.showBody ? 'down' : 'right'} onClick={() => this.setState({ showBody: !this.state.showBody, showHistory: false })} />
					</div>

					{this.state.showBody && <div className='task-body' dangerouslySetInnerHTML={{ __html: item.body }}></div>}
					{this.state.showHistory && <div className='task-history'>
						<TaskHistory
							items={item.dynamicProperties.history}
						/>
					</div>}
				</div>
			</div>);
	}

}


interface HistoryItem {
	reason: string;
	date: Date;
	userTaskModifiedBy: string;
	changes: { name: string, after: object, before: object }[]
	open: boolean;
}

interface ITaskHistoryProps {
	items: HistoryItem[];
}

interface ITaskHistoryState {

}


export class TaskHistory extends React.Component<ITaskHistoryProps, ITaskHistoryState>{

	@resolve
	formatService: FormatService;

	getStateString = (state) => {
		console.log(state);

		switch (state) {

			case 'InProgress':
				return 'In progress';
			case 'OutOfDate':
				return 'Out of date';
		}

		return state;
	}

	renderSingleProperty = (name: string, value: any) => {

		switch (name) {
			case 'State':
				return <div className={'user-state state' + value}>{this.getStateString(value)}</div>
			case 'AssignedToId':
				return <UserEditorController
					value={value}
					label=''
					mode='display'
					setBusy={e => { }}
				/>
			case 'Daedline':
				return <label className='prop-value'>{this.formatService.toString('small-date-time', value)}</label>

			default:
				return <div className='prop-value' dangerouslySetInnerHTML={{ __html: value }}></div>
		}

	}

	getName = (name: string) => {

		switch (name) {
			case 'Daedline':
				return 'Deadline';
			case 'AssignedToId':
				return "Assigned to";
		}

		return name;
	}

	renderProperty = (name: string, after: any, before: any) => {

		if (name == 'DynamicProperties' || name == 'Timestamp')
			return null;

		return (<div key={name} className='prop-container'>
			<p className='prop-name'>{this.getName(name)}</p>
			<div className='prop-values'>
				{this.renderSingleProperty(name, before)}
				<div className="process"><strong> to </strong></div>
				{this.renderSingleProperty(name, after)}
			</div>
		</div>);
	}

	render() {
		return (<div className='task-history'>
			{this.props.items && this.props.items.map(item => {

				if (item.open)
					return null;

				return (<div className='history-item' key={item.date + ''}>
					<p className='item-date'>{this.formatService.toString('small-date-time', item.date)}</p>

					<div className='content'>
						{item.userTaskModifiedBy && <p className='modif-name'>Modified by: <strong>{item.userTaskModifiedBy}</strong></p>}
						{item.reason && <p className='reason'>Change Reason: <strong>{item.reason}</strong></p>}


						{item.changes && item.changes.map(change => {
							return this.renderProperty(change.name, change.after, change.before);
						})
						}
					</div>

				</div>)
			})}
		</div>);
	}
}



// WEBPACK FOOTER //
// ./src/app/general/user-tasks/parts/task-card.tsx